import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { ClipboardCheck, Target, Users, MessageCircle, HandHeart, Cake, Zap } from "lucide-react";

const MEMBER_ROLES = ["membro", "visitante"];

const LEADER_ACTIONS = [
  { label: "Registrar frequência", to: "/frequencia", icon: ClipboardCheck, module: "frequencia" },
  { label: "Nova meta", to: "/metas", icon: Target, module: "metas" },
  { label: "Ver meus grupos", to: "/grupos", icon: Users, module: "grupos" },
  { label: "Atendimento", to: "/atendimento", icon: MessageCircle, module: "atendimento" },
];
const MEMBER_ACTIONS = [
  { label: "Encontrar meu grupo", to: "/grupos", icon: Users, module: "grupos" },
  { label: "Enviar pedido de oração", to: "/oracoes", icon: HandHeart, module: "oracoes" },
  { label: "Aniversariantes", to: "/aniversariantes", icon: Cake, module: "aniversariantes" },
];

export function QuickActions() {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;
  const isMember = MEMBER_ROLES.includes(user.role);
  const base = isMember ? MEMBER_ACTIONS : LEADER_ACTIONS;
  const mods = user.allowed_modules || [];
  const actions = base.filter((a) => user.is_admin || mods.includes(a.module));
  if (actions.length === 0) return null;

  return (
    <Card className="p-5" data-testid="quick-actions-card">
      <h3 className="font-display text-base font-semibold flex items-center gap-2 mb-4">
        <Zap className="h-4 w-4 text-accent" /> Ações rápidas
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {actions.map((a) => (
          <button key={a.to + a.label} onClick={() => navigate(a.to)} data-testid={`quick-action-${a.module}`}
            className="group flex flex-col items-center justify-center gap-2 rounded-2xl border border-border bg-secondary/40 px-3 py-4 text-center hover:border-primary/40 hover:bg-primary/5 transition-colors">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:scale-105 transition-transform">
              <a.icon className="h-5 w-5" />
            </span>
            <span className="text-sm font-medium leading-tight">{a.label}</span>
          </button>
        ))}
      </div>
    </Card>
  );
}
